module.exports = __webpack_public_path__ + "img/premium_.4e5d670d.svg";